import PeImage from '@pe-libs/react-components/build/components/PeImage';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC } from 'react';
import messages from './messages';
import useStyles from './styles';

type PropsType = {
  avatar: string;
  headerUrlFull: string;
  headerUrlMedium: string;
};

const HeroImage: FC<PropsType> = ({ avatar, headerUrlFull, headerUrlMedium }) => {
  const styles = useStyles({ headerUrlFull, headerUrlMedium });
  const formatMessage = useIntlMessage();

  return (
    <div className={styles.heroContainer}>
      <div className={styles.avatarContainer}>
        <PeImage width="165px" height="165px" src={avatar} />
      </div>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>{formatMessage(messages.heroTitle)}</h1>
        <div className={styles.description}>{formatMessage(messages.heroDescription)}</div>
      </div>
    </div>
  );
};

export default HeroImage;
